"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pointsEndpoints = void 0;
const awardPoints_endpoint_1 = require("root/src/server/points/endpoints/awardPoints.endpoint");
const addPaidOffPlatformPoints_endpoint_1 = require("root/src/server/points/endpoints/addPaidOffPlatformPoints.endpoint");
exports.pointsEndpoints = Object.assign(Object.assign({}, awardPoints_endpoint_1.awardPointsEndpoint), addPaidOffPlatformPoints_endpoint_1.addPaidOffPlatformPointsEndpoint);
